// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"09ecca59","230":"fd652ad8","354":"2c307cbb","691":"7e550166","712":"c6843283","753":"cb1c1a08"}[chunkId] + ".chunk.js";
};